import { render, staticRenderFns } from "./PendingWo.vue?vue&type=template&id=2e804140"
import script from "./PendingWo.vue?vue&type=script&lang=js"
export * from "./PendingWo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports